import { supabase } from "./supabaseClient";

/**
 * Fetches a quiz wrapper by ID.
 * @param {string} quizId - The quiz ID.
 * @returns {Promise<{data: Object|null, error: any}>} - Returns the quiz wrapper or error.
 */
export const fetchQuizWrapper = async (quizWrapperId) => {
	try {
		const { data, error } = await supabase
			.from("quiz_wrappers")
			.select("*")
			.eq("id", quizWrapperId)
			.single();

		if (error && error.code !== "PGRST116") {
			console.error("Error fetching quiz wrapper:", error);
		}

		return { data, error };
	} catch (error) {
		console.error("Unexpected error fetching quiz wrapper:", error);
		return { data: null, error };
	}
};
